import { render, staticRenderFns } from "./SetupIntro.vue?vue&type=template&id=09b780e9"
import script from "./SetupIntro.vue?vue&type=script&lang=ts"
export * from "./SetupIntro.vue?vue&type=script&lang=ts"
import style0 from "./SetupIntro.vue?vue&type=style&index=0&id=09b780e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports